<template>
  <div>
    <div>
      <el-radio-group v-model="radio" size="small" @change="handleClickradio" style="background: #fff;width: 100%;">
        <el-radio-button label="1">卷板</el-radio-button>
        <el-radio-button label="2">建材</el-radio-button>
      </el-radio-group>
      <div v-show="radio==1">
        <div class="formBox margbot" ref="searchBoxJB">
          <el-form :inline="true" :model="formDataJB" label-width="95px" size="mini" style="width: 100%;">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select size="mini" filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple>
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName" :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="捆包编号:">
              <el-input  v-model="gangJuanNum"  size="mini" placeholder="可支持多个" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="入库单编号：">
              <el-input class="ipt" v-model="formDataJB.instockNo" placeholder="请输入入库单编号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="入库车牌号">
              <el-input class="ipt" v-model="formDataJB.instockPlateNumberList" placeholder="请输入入库车牌号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="规格:">
              <el-input v-model="formDataJB.specification" size="mini" placeholder="请输入规格" ></el-input>
            </el-form-item>
            <el-form-item label="客户名称:">
              <el-input class="ipt" v-model="formDataJB.customerName" placeholder="请输入客户名称" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="入库客户:">
              <el-input class="ipt" v-model="formDataJB.inCustomerName" placeholder="请输入入库客户" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="合约编号:">
              <el-input class="ipt" v-model="formDataJB.agreementNumber" filterable placeholder="请输入合约号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select size="mini" v-model="formDataJB.productType" filterable clearable placeholder="请选择货物类型" >
                <el-option v-for="item in typeData" :label="item.show_name" :key="item.show_name" :value="item.item_no"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:">
              <div style="display: flex;">
              <el-date-picker v-model="formDataJB.createTimeStart" size="mini" type="datetime" placeholder="请选择入库日期" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              -
              <el-date-picker v-model="formDataJB.createTimeEnd" size="mini" placeholder="请选择入库日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="合同编号:">
              <el-input class="ipt" v-model="formDataJB.contractNumber" placeholder="请输入合同号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="进仓单号:">
              <el-input class="ipt" v-model="formDataJB.jFInstockNo" placeholder="请输入进仓单号" size="mini" ></el-input>
            </el-form-item>
            </div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxunJB" btnCode="00ZP00CB007" v-if="btnFlg[6]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongzhiJB" btnCode="00ZP00CB008" v-if="btnFlg[7]">重置</el-button>
              <el-button type="primary" size="mini" @click="daochuJB" btnCode="00ZP00CB009" v-if="btnFlg[8]">导出</el-button>
              <span style="margin-left:10px">总吨数：<span style="color:red">{{Number(allWeightJB)}}</span> 吨</span>
              <span style="margin-left:10px">总件数：<span style="color:red">{{allNumberJB}}</span> 件</span>
            </el-form-item>
          </el-form>
        </div>
        <div :style="{height:h}">
          <el-table border center bordersize="mini" :data="tableDataJB" class="tableComent" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="jfInstockDate" label="确认时间" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="jFInstockNo" label="进仓单号" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inCustomerName" label="入库客户" align="center" width="230"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center" width="230"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库名" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位名" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位名" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单编号" align="center" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="入库日期" align="center" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inCreateUser" label="入库单创建人" align="center" width="110"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库操作人" align="center" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="jfInstockUserName" label="确认人" align="center" width="150"></el-table-column>
          </el-table>
        </div>
        <div class="pags">
          <el-pagination background @current-change="handleCurrentChangeJB" :current-page="pageInfoJB.pageNo" :page-size="pageInfoJB.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJB" :total="totalJB"></el-pagination>
        </div>
      </div>
      <!-- 建材 -->
      <div v-show="radio==2">
        <div class="formBox margbot" ref="searchBoxJC">
          <el-form :inline="true" :model="formDataJC" label-width="95px" size="mini" style="width: 100%;">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select size="mini" filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple @change="clickCK()" >
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName" :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入库单号:">
              <el-input class="ipt" v-model="formDataJC.instockNo" placeholder="请输入入库单号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input class="ipt" v-model="formDataJC.instockPlateNumber" placeholder="请输入车号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="进仓单号:">
              <el-input class="ipt" v-model="formDataJC.inWarehouseNo" placeholder="请输入进仓单号" size="mini" ></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-input v-model="formDataJC.primaryCustomerName" size="mini" placeholder="请输入一级货主" ></el-input>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-input v-model="formDataJC.customerName" size="mini" placeholder="请输入二级货主" ></el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="formData.productType" clearable placeholder="请选择货物类型" filterable size="mini" >
                <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="formData.steelMillName" clearable placeholder="请选择产地" filterable size="mini" >
                <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格:">
              <el-select v-model="formData.specification" clearable placeholder="请选择规格" filterable size="mini" >
                <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质:">
              <el-select v-model="formData.model" clearable placeholder="请选择材质" filterable size="mini" >
                <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="确认时间:">
              <div style="display: flex;">
              <el-date-picker v-model="formDataJC.confirmTimeStart" size="mini" type="datetime" placeholder="请选择确认时间" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              -
              <el-date-picker v-model="formDataJC.confirmTimeEnd" size="mini" placeholder="请选择确认时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="到货方式:">
              <el-select v-model="formDataJC.arrivalMethod" clearable placeholder="请选择到货方式" filterable size="mini" >
                <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
           </div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxunJC" btnCode="00ZP00CB00A" v-if="btnFlg[9]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongzhiJC" btnCode="00ZP00CB00B" v-if="btnFlg[10]">重置</el-button>
              <el-button type="primary" size="mini" @click="daochuJC" btnCode="00ZP00CB00C" v-if="btnFlg[11]">导出</el-button>
              <span style="margin-left:10px">总吨数：<span style="color:red">{{Number(allWeightJC)}}</span> 吨</span>
              <span style="margin-left:10px">总件数：<span style="color:red">{{allNumberJC}}</span> 件</span>
            </el-form-item>
          </el-form>
        </div>
        <div :style="{height:H}">
          <el-table border center bordersize="mini"  class="tableComent" :data="tableDataJC" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="handleRowClick">
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column prop="organizationName" label="仓库名称" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockTime" label="入库时间" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="confirmName" label="确认人" width="150"></el-table-column>
          </el-table>
        </div>
        <div class="pags">
          <el-pagination background @current-change="handleCurrentChangeJC" :current-page="pageInfoJC.pageNo" :page-size="pageInfoJC.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJC" :total="totalJC"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getVirtualBalingList,
  getDictionaryAll,
  getWarehousingList,
  getWarehousingNumber,
  findUserTenantRelList,
  getInStockList,
  getInStockListAllWeight
} from '@/api/wms-stock'
import { zidian } from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'

export default {
  name: 'JCRecord',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      radio: 1,
      // 卷板
      total: 0,
      pageInfoJB: {
        pageNo: 1,
        pageSize: 20
      },
      formDataJB: {
        productType: '',
        agreementNumber: '',
        customerName: '',
        inCustomerName: '',
        instockPlateNumberList: '',
        createTimeStart: '',
        createTimeEnd: '',
        contractNumber: '',
        specification: '',
        jFInstockNo: ''
      },
      tableDataJB: [],
      allWeightJB: 0,
      allNumberJB: 0,
      totalJB: 0,
      formData: {
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      },
      // 建材
      formDataJC: {
        inWarehouseNo: '',
        instockNo: '',
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: ''
      },
      pageInfoJC: {
        pageNo: 1,
        pageSize: 20
      },
      totalJC: 0,
      allWeightJC: 0,
      allNumberJC: 0,
      tableDataJC: [],
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        '00ZP00CB001',
        '00ZP00CB002',
        '00ZP00CB003',
        '00ZP00CB004',
        '00ZP00CB005',
        '00ZP00CB006',
        '00ZP00CB007',
        '00ZP00CB008',
        '00ZP00CB009',
        '00ZP00CB00A',
        '00ZP00CB00B',
        '00ZP00CB00C',
        '00ZP00CB00D',
        '00ZP00CB00E',
        '00ZP00CB00F',
        '00ZP00CB00G',
        '00ZP00CB00H',
        '00ZP00CB00I',
        '00ZP00CB00J',
        '00ZP00CB00K',
        '00ZP00CB00L',
        '00ZP00CB00M',
        '00ZP00CB00N',
        '00ZP00CB00O'
      ],
      btnFlg: [],
      tableData: [],
      h: 500,
      H: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: [],
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      CKData: [],
      CKName: [],
      typeId: '', // 冷热卷
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      typeName: '',
      typeData: [],
      gangJuanNum: '',
      // 字典
      addKuwei: [],
      addQ: [],
      addH: []
    }
  },
  props: {
    JCVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 仓库改变
    clickCK () {
      this.getVirtualBalingList()
    },
    // 字典货物类型卷板
    zidianS () {
      getDictionaryAll({
        groupNo: 'product_type'
      })
        .then(res => {
          this.typeData = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList(
        {
          userCode: window.localStorage.getItem('userCode'),
          tenantCode: window.localStorage.getItem('tenantCode')
        }
      )
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleClickradio () {
      if (this.radio == 1) {
        this.chongzhiJB()
      } else {
        this.chongzhiJC()
        let H = this.$refs.searchBoxJC.offsetHeight
        let pHJC = document.documentElement.clientHeight
        this.H = pHJC - H - 235 + 'px'
      }
    },
    // 卷板
    chaxunJB () {
      getInStockList(
        {
          ...this.formDataJB,
          ...this.pageInfoJB,
          organizationFlag: '1',
          cargoStatus: '1',
          jfInstockFlag: '2',
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(',')
        }
      )
        .then(res => {
          console.log(res)
          this.tableDataJB = res.pageInfo.list
          this.totalJB = res.pageInfo.total
          getInStockListAllWeight({
            ...this.formDataJB,
            cargoStatus: '1',
            jfInstockFlag: '2',
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
            organizationFlag: '1'
          })
            .then(res => {
              console.log(res)
              this.allWeightJB = res.weight.allWeight
              this.allNumberJB = res.weight.allNumber
            })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhiJB () {
      this.pageInfoJB = {
        pageNo: 1,
        pageSize: 20
      }
      this.formDataJB = {
        productType: '',
        agreementNumber: '',
        customerName: '',
        inCustomerName: '',
        instockPlateNumberList: '',
        createTimeStart: '',
        createTimeEnd: '',
        contractNumber: '',
        specification: '',
        jFInstockNo: ''
      }
      this.CKName = []
      this.gangJuanNum = ''
      this.chaxunJB()
    },
    daochuJB () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportInStockList',
        {
          ...this.formDataJB,
          organizationFlag: '1',
          cargoStatus: '1',
          jfInstockFlag: '2',
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(',')
        },
        '进仓记录表'
      )
    },
    handleCurrentChangeJB (val) {
      this.pageInfoJB.pageNo = val
      this.chaxunJB()
    },
    handleSizeChangeJB (val) {
      this.pageInfoJB.pageSize = val
      this.chaxunJB()
    },
    // 列表查询
    getWarehousingList () {
      getWarehousingList(
        {
          ...this.formDataJC,
          ...this.formData,
          ...this.pageInfoJC,
          organizationIds: this.CKName.join(',')
        }
      )
        .then(res => {
          console.log(res)
          this.tableDataJC = res.list
          this.totalJC = res.total

          this.getWarehousingNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总吨数总件数
    getWarehousingNumber () {
      getWarehousingNumber({ ...this.formDataJC, ...this.formData, organizationIds: this.CKName.join(',') })
        .then(res => {
          console.log(res)
          // this.allWeightJC = res.totalAllWeight
          this.allWeightJC = parseFloat(res.totalAllWeight.toFixed(6))

          this.allNumberJC = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList(
        {
          organizationFlag: 1
        }
      )
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 建材
    chaxunJC () {
      this.getWarehousingList()
    },
    chongzhiJC () {
      this.formDataJC = {
        inWarehouseNo: '',
        instockNo: '',
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: ''
      }
      this.pageInfoJC = {
        pageNo: 1,
        pageSize: 20
      }
      this.formData = {
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      }
      this.CKName = []
      this.chaxunJC()
    },
    daochuJC () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportWarehousingList',
        {
          ...this.formDataJC,
          ...this.formData,
          organizationIds: this.CKName.join(',')
        },
        '进仓记录表'
      )
    },
    handleCurrentChangeJC (val) {
      this.pageInfoJC.pageNo = val
      this.chaxunJC()
    },
    handleSizeChangeJC (val) {
      this.pageInfoJC.pageSize = val
      this.chaxunJC()
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      // this.getControlAuditLists()
    },
    handleRowClick (row) {
      this.xuanzhongArr = row
    }
  },
  created () {
    this.findUserTenantRelList()
    this.chaxunJB()
    this.chaxunJC()
    this.zidianS()
    this.btnFlg = getBtn(this.btnArr, '/ChuRuReport')
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBoxJB.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 235 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox1 {
   /deep/.el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
